import type { Procedure } from '../../../app-core/lib/procedure/Procedure'
import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'

export function IDB_procedureRead(id: number) {
    return IDB_rowRead<Procedure>(IDB_globalDb, 'campaigns', id)
}

export function IDB_proceduresDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'campaigns', ids)
}

export function IDB_proceduresReadAll() {
    return IDB_rowsReadAll<Procedure>(IDB_globalDb, 'campaigns')
}

export function IDB_proceduresWrite(campaigns: Procedure[]) {
    return IDB_rowsWrite(IDB_globalDb, 'campaigns', campaigns)
}

export function IDB_procedureWrite(campaign: Procedure) {
    return IDB_rowWrite(IDB_globalDb, 'campaigns', campaign)
}
